import { toCamel } from '~/utils/toCamelCase';
export function updateMetadataList(parentObj, propertyName) {
    return parentObj.map(item => {
        var _a;
        const newMetadataFields = (_a = item[propertyName]) === null || _a === void 0 ? void 0 : _a.map(doc => {
            const metadataFields = [];
            for (const [index, val] of Object.entries(doc)) {
                const newKey = index.toLowerCase().replace(/\s/g, '_');
                metadataFields.push({ name: toCamel(newKey), value: val });
            }
            return metadataFields;
        });
        return Object.assign(Object.assign({}, parentObj), { [propertyName]: newMetadataFields });
    });
}
export function updateMetadata(parentObj, propertyName) {
    return parentObj === null || parentObj === void 0 ? void 0 : parentObj.map(item => {
        var _a;
        const newMetadataFields = [];
        for (const [index, val] of Object.entries((_a = item[propertyName]) !== null && _a !== void 0 ? _a : {})) {
            const newKey = index.toLowerCase().replace(/\s/g, '_');
            newMetadataFields.push({ name: toCamel(newKey), value: val });
        }
        return Object.assign(Object.assign({}, item), { [propertyName]: newMetadataFields });
    });
}
export function transformMetaData(value) {
    const newMetadataFields = [];
    for (const [index, val] of Object.entries(value)) {
        const newKey = index.toLowerCase().replace(/\s/g, '_');
        newMetadataFields.push({ name: toCamel(newKey), value: val });
    }
    return newMetadataFields;
}
